import { invokeFunction } from '../api'
import { toApiRequestError } from '../errors'

export type ResponseValue = 'compliant' | 'non_compliant' | 'not_applicable'

interface UpsertResponseInput {
    visitId: string
    templateId: string
    responseValue: ResponseValue
    notes?: string
}

export interface ChecklistResponseRecord {
    response_id: string
    template_id: string
    response_value: string
    notes?: string | null
}

export function toBackendResponseValue(value: 'Compliant' | 'Non-Compliant' | 'Not Applicable'): ResponseValue {
    if (value === 'Compliant') return 'compliant'
    if (value === 'Non-Compliant') return 'non_compliant'
    return 'not_applicable'
}

export async function upsertResponse(input: UpsertResponseInput): Promise<ChecklistResponseRecord> {
    const { data, error } = await invokeFunction<ChecklistResponseRecord>('responses', {
        method: 'POST',
        path: `/visits/${input.visitId}/responses:upsert`,
        body: {
            template_id: input.templateId,
            response_value: input.responseValue,
            notes: input.notes?.trim() ? input.notes.trim() : undefined,
        },
    })

    if (error || !data) {
        throw toApiRequestError(error, 'Failed to save response')
    }

    return data
}

export async function listResponses(visitId: string): Promise<ChecklistResponseRecord[]> {
    const { data, error } = await invokeFunction<{ responses: ChecklistResponseRecord[] }>('responses', {
        method: 'GET',
        path: `/visits/${visitId}/responses`,
    })

    if (error) {
        throw toApiRequestError(error, 'Failed to load responses')
    }

    // Edge function returns responses as an object keyed by template_id, not an array
    const raw = data?.responses
    if (!raw) return []
    if (Array.isArray(raw)) return raw
    return Object.values(raw) as ChecklistResponseRecord[]
}
